import { render, staticRenderFns } from "./FunctionServiceProviders.vue?vue&type=template&id=bd04ea0a&"
import script from "./FunctionServiceProviders.vue?vue&type=script&lang=js&"
export * from "./FunctionServiceProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports